import {useRouteLoaderData} from '@remix-run/react'
import React from 'react'
import type {RootLoaderResponse} from '~/types'

interface GoogleAnalyticsProps {
  fcbPixelId?: string
}

export const FcbPixelScript = ({fcbPixelId}: GoogleAnalyticsProps) => {
  const {cookieConsentVariation, gdprConsentData} = useRouteLoaderData('root') as RootLoaderResponse
  const defaultConsent = cookieConsentVariation === 'opt-in' ? 'denied' : 'granted'
  const consentGranted = (gdprConsentData ?? defaultConsent) === 'granted' || gdprConsentData === 'granted'

  return (
    <>
      <script
        id="fcb-pixel"
        async
        dangerouslySetInnerHTML={{
          __html: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('consent', '${consentGranted ? 'grant' : 'revoke'}');
          fbq('init', '${fcbPixelId}');
          ${consentGranted ? "fbq('track', 'PageView');" : ''}
        `,
        }}
      />
      $
      {consentGranted
        ? `
      <noscript>
        <img
          alt="fcb-pixel"
          height="1"
          width="1"
          style={{display: 'none'}}
          src={\`https://www.facebook.com/tr?id=${fcbPixelId}&ev=PageView&noscript=1\`}
        />
      </noscript>
      `
        : ''}
    </>
  )
}
